module.exports = __webpack_public_path__ + "img/SketchPng031e078f116d99b06f0ca168149f62580a7eef1ea9101d7305e6364de5093080.1c712bfc.png";